import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import { CustomHandler } from "@tKgpco/Store/CustomHandlerCreator";

type HandlerType = CustomHandler<{ poNumberError: string }>;

export const DispatchPONumberError: HandlerType = props => {
    props.dispatch({
        type: "Custom/CheckoutReview/PoNumberError",
        poNumberError: props.parameter.poNumberError,
    });
};

export const chain = [DispatchPONumberError];

const setPONumberError = createHandlerChainRunner(chain, "setPONumberError");
export default setPONumberError;
